// extracted by mini-css-extract-plugin
module.exports = {"cta":"exclusive_cta__IIF4l","img__cta":"exclusive_img__cta__0Z9cg"};